// =============================
// Imports
// =============================

import { Component } from 'react';
import PropTypes from 'prop-types';

import * as playerCtx from '../../../../store/constants/PlayerContexts';

import CoverSlider from '../../../presentationals/coverslider';
import Link from '../../../other/link';

import { presentShortDescription } from '../../../../helpers/entity/common';
import {
  getPlaylistTitle,
  getPlaylistCoverUrl,
  getPlaylistTracksCoversUrl,
} from '../../../../helpers/entity/playlist';
import { getBaseRoute, getUrl } from '../../../../helpers/entity';
import * as pth from '../../../../helpers/proptypes';

// =============================
// Stories
// =============================

class SuggestedPlaylists extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    suggestedPlaylists: PropTypes.arrayOf(pth.suggestedplaylist).isRequired,
    t: PropTypes.func.isRequired,
  };

  render() {
    const { locale, suggestedPlaylists, t } = this.props;

    return (
      <CoverSlider
        title={t('pages:suggested_playlists.title')}
        covers={suggestedPlaylists.map(playlist => ({
          key: playlist.id,
          title: getPlaylistTitle(playlist),
          src: getPlaylistCoverUrl(playlist) || getPlaylistTracksCoversUrl(playlist),
          type: 'playlist',
          placeholderType: 'playlist',
          linkProps: {
            route: getBaseRoute('playlists'),
            nextAs: getUrl('playlists')(playlist),
          },
          description: presentShortDescription(playlist.descriptions, locale, 70),
          contextName: playerCtx.PLAYLIST,
          contextId: playlist.id,
        }))}
        LinkComponent={Link}
      />
    );
  }
}

export default SuggestedPlaylists;
